import axios from "axios";
import store from "../../store/index";
import Multiselect from "@vueform/multiselect";
import customModal from "../customModal/customModal.vue";


import "@hennge/vue3-pagination/dist/vue3-pagination.css";

export default {
    name: 'assignFormSdvModal',
    components: {
        Multiselect,
        customModal,

    },
    props: {
      
        selectedFormId: {
              type: String,
              default: "",
        },
        templateId: {
            type: String,
            default: "",
        },
        
    },
    data() {
        return {
            baseapi: process.env.VUE_APP_Service_URL,
            loadingBlock: false,
            sdvInfo: {},
            roleList: [],
            selectedRole: "",     
            recipients: [],      
            values: {
                Recipient: ""      
            }, 
        };
    },
    mounted() {
        window.addEventListener("studyIdChanged", async (event) => {
            this.studyId = store.getters.getStudyIs;
            await this.getAssignInfo();
            await this.getRoleList(); 
        });
       
        this.studyId = store.getters.getStudyIs;
        this.token = store.getters.getIdToken;
        this.head = {
            headers: {
                Authorization: "Bearer " + this.token,
                "Content-Type": "application/json",
            },
        };
        this.getAssignInfo();
        this.getRoleList(); 
    },
    methods: {
        async getAssignInfo() {
            try {
                const res = await axios.get(
                    `${this.baseapi}/forms/rbqm/getecrfsdvmap`,
                    {
                        headers: this.head.headers,
                        params: {
                            studyId: this.studyId || store.getters.getStudyIs,
                            templateId: this.templateId,
                        },
                    }
                );
                // API may return the mapping directly or inside `entities`
                const payload = res.data?.entities?.[0] || res.data || {};
                this.sdvInfo = payload;
            } catch (err) {
                console.log(err);
            }
        },
       async assignSdv() {
           
            try {
                await axios.post(
                    `${this.baseapi}/forms/rbqm/createformsdv`,
                    {
                        studyId: this.studyId,
                        formId: this.selectedFormId,
                        AssignedToEmail: this.values.Recipient,
                    },
                    this.head
                );
                
                alert("SDV Assigned successfully");                
                this.$emit("closeModal");
            } catch (err) {
                console.log("Error Assigning  SDV ", err);
            }
        },
   closeSdvModal() {
    this.$emit("closeModal"); // emits to parent component
  },
        async getRoleList() {
            const idtoken = store.getters.getIdToken;
             axios
                .get(
                `${this.baseapi}/account-core/roles/rolelist`,
                {
                    headers: {
                    Authorization: "Bearer " + idtoken,
                    "Content-Type": "application/json",
                    },
                }
                ).then((res) => {
                    this.roleList = res.data;
                })
        },
        async getRoleBasedUserlist(roleId) {
      try {
        console.log("sdasdasdssassssssssssss",roleId);
        const studyId = store.getters.getStudyIs;
        const res = await axios.get(
          `${this.baseapi}/account-core/user/getusersbyrole?roleids=${roleId}&studyid=${studyId}`,
          this.head
        );
        this.recipients = res.data;
      } catch (err) {
        console.error("Error fetching users by role", err);
        this.recipients = [];
      }
    },
 
    async roleChanged() {
      console.log("Selected role:", this.selectedRole); 
      if (this.selectedRole) {
        await this.getRoleBasedUserlist(this.selectedRole);
        this.values.Recipient = ""; 
      } else {
        this.recipients = [];
        this.values.Recipient = "";
      }
    },
        

    },


}
